/**
 * @author        matt@zumper.com (Matthieu Devlin)
 * @copyright     Copyright (c) 2018, Zumper
 * @description   list item event thunk
 */

import { getUser } from '@zcode-ui/web-zumper-global-state'
import { event, getEntityProperties } from '@zcode-ui/web-zumper-integrations'
import type { TopListable } from '@zcode/bizos'
import { getRouteProps } from '@zcode/nr/es/shared/packages/history-middleware'
import type { Listable, MaybeEmptyProperty, Pin, RawPinInventorySearch } from '@zcode/state-type'
import type { MaybeEmpty } from '@zcode/utility-types'
import { routes } from '@zcode/zumper-routes'
import { getCurrentLocation } from '../../../inspectors/index'
import type { Dispatch, GetState } from '../../types'
import { getFilters } from './getFilters'
import { type AdditionalProps, getTraktorPageType } from './trackDetailEvent'

export interface TrackListItemEventProps {
  name: string
  entity:
    | MaybeEmptyProperty
    | MaybeEmpty<Listable>
    | Pin<RawPinInventorySearch>
    | TopListable
    | null
    | undefined
  additionalProps?: Partial<AdditionalProps>
}

export const trackListItemEvent =
  ({ name, entity, additionalProps }: TrackListItemEventProps) =>
  (dispatch: Dispatch, getState: GetState) => {
    const state = getState()

    const user = getUser(state)
    const filters = getFilters(state, entity)
    const location = getCurrentLocation(state)

    const { match } = dispatch(getRouteProps({ routes }))
    const listItemEventProps = getEntityProperties(entity ?? {}, state)
    const props = {
      pageType: getTraktorPageType(entity ?? {}, match, state),
      ...listItemEventProps,
      ...additionalProps,
    }
    dispatch(event({ name, props, user, filters, location }))
  }
